import { useSearchParams } from "react-router-dom";
import Renderer from "./Renderer";
import DailyFollowups from "./Followup";
import Untouched from "./Untoched";

const LeadScreen = () => {
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view") || "";

  if (view === "system:followups") {
    return <DailyFollowups />;
  }

  if (view === "system:untouched") {
    return <Untouched />;
  }

  return <Renderer />;
};

export default LeadScreen;
